/**
 * @flow
 * @relayHash e5a9d47a0e63991319f7e1805d0ba3c4
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type disapproveHyeventInput = {|
  clientMutationId?: ?string,
  id: string,
  disapproveReason: string,
|};
export type disApproveEventMutationVariables = {|
  input: disapproveHyeventInput
|};
export type disApproveEventMutationResponse = {|
  +disapproveHyevent: ?{|
    +clientMutationId: ?string,
    +hyevent: ?{|
      +id: string,
      +status: string,
    |},
  |}
|};
export type disApproveEventMutation = {|
  variables: disApproveEventMutationVariables,
  response: disApproveEventMutationResponse,
|};
*/


/*
mutation disApproveEventMutation(
  $input: disapproveHyeventInput!
) {
  disapproveHyevent(input: $input) {
    clientMutationId
    hyevent {
      id
      status
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "disapproveHyeventInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "disapproveHyevent",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "disapproveHyeventPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "clientMutationId",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "hyevent",
        "storageKey": null,
        "args": null,
        "concreteType": "Hyevent",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "status",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "disApproveEventMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "disApproveEventMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "disApproveEventMutation",
    "id": null,
    "text": "mutation disApproveEventMutation(\n  $input: disapproveHyeventInput!\n) {\n  disapproveHyevent(input: $input) {\n    clientMutationId\n    hyevent {\n      id\n      status\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'aceef5fd20fd3b5a9058756831c2665b';
module.exports = node;
